import React from "react";
import { db } from "@react-native-firebase/database";
import StyleSheetRW from "core/StyleSheetRW";
import { get, ref, set, push } from "firebase/database";
import { useEffect, useRef, useState } from "react";
import { Dimensions } from "react-native";
import { MOBILE_VIEW_WIDTH } from "res/constants";
import Dialog from "src/components/Dialog";
import Loader from "src/components/Loader";
import Menu from "./Menu";
import { Text, View } from "react-native";
import { BsPenFill } from "react-icons/bs";
import DropDownField from "src/components/DropDownField";
import { TouchableOpacity } from "react-native";
import { AddReviewAssignmentForm } from "./AddReviewAssignment";
import { getLocalStorageItem } from "core/helpers";
import navhelper from "core/navhelper";
const UserReviewScreen = () => {
  const [showLoader,setShowLoader]=useState(false)
  const loggedinUser = getLocalStorageItem("loggedinUser");
  const screenWidth=Dimensions.get('window').width;
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [reviewList,setReviewList]=useState([])
  const fetchReviews = async () => {
    setShowLoader(true)
    try {
      const dbRef = ref(db, `reviewAssignment`);
      await get(dbRef).then((snapshot) => {
        if (snapshot.exists()) {
          const reviewFetchedData = snapshot.val();
          const reviewsArray = Object.keys(reviewFetchedData).map((key) => ({
            id: key,
            ...reviewFetchedData[key],
          }));
          const ReviewerUserID=loggedinUser.uid;
          console.log(reviewsArray);
          const filteredValue=reviewsArray.filter((review)=>review.ReviewerUserID===ReviewerUserID)
          if(filteredValue){
            setReviewList(filteredValue)}
          else
          {
            setReviewList([])
          }
        }
            setShowLoader(false)
      });
    } catch {
      console.log("ERROR");
      setShowLoader(false)
    }
  };
  useEffect(() => {
    fetchReviews();
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
    <Menu />
    <div
      ref={scrollContainerRef}
      style={{
        overflowX: "hidden",
        width:  "100%",
        padding: "0px 0px 0px 20px",
      }}
    >
      <div
        style={{
          width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "97%",
          fontFamily: "Outfit",
        }}
      >      
        
        <div
          style={{
            textAlign: "center",
            width: "100%",
            fontSize: 36,
            fontWeight: "700",
            marginTop:20,
            color: "#2F4858",
          }}
        >
         Assigned Reviews List
        </div>
        <div style={{ overflowY: "scroll" ,overflowX:'hidden',marginTop:20,scrollbarWidth:'none'}}>
      <table
              style={{
                marginBottom: 20,
                borderCollapse: "collapse",
                backgroundColor: "#FFFFFF66",
                width: "100%",
              }}
            >
      <thead style={{ fontSize: 14 }}>
                <tr style={{ backgroundColor: "#2F4858", color: "#FFFFFF" }}>
                  <th style={{ border: "1px solid black", padding: "15px" }}>
                    User to be Reviewed
                  </th>
                  <th style={{ border: "1px solid black", padding: "15px" }}>
                   Role
                  </th>
                  <th style={{ border: "1px solid black", padding: "15px" }}>
                    Action
                  </th>
                </tr>
              </thead>
        <tbody>
        
              {reviewList.map((review,index)=>(
                <>
{ review.status!=='Submitted'&&         <tr key={review.id} style={{ backgroundColor: index % 2 === 1 ? "#2F48581A" : undefined }}>
              <td style={{ borderLeft: '0px', padding: '15px' }}>{review.ReviewedUserName}</td>
              <td style={{ borderLeft: '1px solid #2F485880', padding: '15px' }}>{review.ReviewerRole}</td>
              <td style={{ borderLeft: '1px solid #2F485880', padding: '15px' }}>
              <div style={{height:'100%',display:'flex',flexDirection:'row',justifyContent:'space-evenly',alignItems:'center'}}>
              <BsPenFill style={{cursor:'pointer'}} onClick={
              ()=>  navhelper.push('ReviewSubmissionScreen',{review:review,mode:'Edit'})
              }/>
              </div>
              </td>
              </tr>}
                 </>
              ))
              }
        </tbody>
      </table>
    </div>
    </div>
    </div>
    {showLoader&&<Loader/>}
    </div>
  );
};

export default UserReviewScreen;
